export function relativeTime(iso: string | null | undefined, now = Date.now()) {
  if (!iso) return "—";
  const diff = Math.round((now - new Date(iso).getTime()) / 1000);
  if (diff < 0) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function absoluteTime(iso: string | null | undefined) {
  return iso ? new Date(iso).toLocaleString() : "";
}

// "success" -> "Success"; used for status/action labels in the run tables.
export function titleCase(value: string) {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}

export function duration(start: string | null | undefined, end: string | null | undefined) {
  if (!start || !end) return "—";
  const secs = Math.max(0, (new Date(end).getTime() - new Date(start).getTime()) / 1000);
  if (secs < 1) return "<1s";
  if (secs < 60) return `${Math.round(secs)}s`;
  const mins = Math.floor(secs / 60);
  return `${mins}m ${Math.round(secs % 60)}s`;
}

export function bytes(n: number | null | undefined) {
  if (n === null || n === undefined) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export function elapsed(fromMs: number, now = Date.now()) {
  const secs = Math.max(0, Math.round((now - fromMs) / 1000));
  if (secs < 60) return `${secs}s`;
  return `${Math.floor(secs / 60)}m ${secs % 60}s`;
}

// Moodle's web service returns names HTML-escaped ("AI &amp; ML"). React
// escapes again on render, so decode once when data enters the app.
const ENTITIES: Record<string, string> = { amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: "\u00a0" };

export function decodeEntities(text: string): string;
export function decodeEntities(text: string | null): string | null;
export function decodeEntities(text: string | null) {
  if (!text || !text.includes("&")) return text;
  return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (match, code: string) => {
    if (code[0] === "#") {
      const n = code[1].toLowerCase() === "x" ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
      return Number.isFinite(n) ? String.fromCodePoint(n) : match;
    }
    return ENTITIES[code.toLowerCase()] ?? match;
  });
}
